<template>
  <component
    :is="currentComponent"
    :data="data"
  />
</template>

<script>
import { findHall } from '@/api/hall'
export default {
  name: 'ShowHallInfo',
  components: {
    HallInUseShow: () => import('@/views/halls/show/mobile/in_use/index'),
    HallIdleShow: () => import('@/views/halls/show/mobile/Idle'),
    HallPauseShow: () => import('@/views/halls/show//mobile/Pause')
  },
  data() {
    return {
      data: {},
      loopFetchDataTimer: null
    }
  },
  computed: {
    id() {
      return parseInt(this.$route.params.id)
    },

    currentComponent() {
      switch (this.data.status_slug) {
        case 'in_use':
          return 'HallInUseShow'
        case 'idle':
          return 'HallIdleShow'
        case 'pause':
          return 'HallPauseShow'
        default:
          return ''
      }
    }
  },
  created() {
    this.fetchData()
    this.loopFetchData()
  },
  destroyed() {
    clearInterval(this.loopFetchDataTimer)
  },
  methods: {
    loopFetchData() {
      this.loopFetchDataTimer = setInterval(this.fetchData, 60000)
    },
    fetchData() {
      findHall(this.id).then((res) => {
        if (res.code === 0) {
          this.data = res.data
        }
      })
    }
  }
}
</script>
